import { Component, OnInit } from '@angular/core';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';

@Component({
  selector: 'app-pending-withdrawals',
  templateUrl: './pending-withdrawals.component.html',
  styleUrls: ['./pending-withdrawals.component.scss'],
})
export class PendingWithdrawalsComponent implements OnInit {

  public error = null;
  public getComplete;
  public pendingWithdrawals: any[] = [];
  public emailMeDisabled: boolean = false;
  public confirm: boolean = false;
  public payoutLock: boolean;

  constructor(
    public withdrawalService: WithdrawalService,
    public config: ConfigService,
    public navigator: Navigator,
    public successMessageService: SuccessMessageService,
  ) {
    this.successMessageService.clearMessage();
    this.error = null;
    
    let appConfigInfo = this.config.getConfig();
    this.payoutLock = appConfigInfo.payoutLock;
  }

  ngOnInit(){
    this.onGetPendingWithdrawals();
  }

  formatPendingWithdrawals(withdrawals) {
    var tempTransactions: any = withdrawals;
    for (let index in tempTransactions) {
      this.pendingWithdrawals.push(tempTransactions[index]);
    }
  }

  pendingWithdrawalsEmiter(data) {
    if (data.success) return  this.onGetPendingWithdrawals();
    if (data.error) return this.error = data.error;
  }

  onGetPendingWithdrawals() {
    this.pendingWithdrawals = [];
    this.withdrawalService.callGetPendingWithdrawals().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.formatPendingWithdrawals(response.payload);
        }
        this.getComplete = true;
      },
      (error) => {
        this.error = error;
        this.getComplete = false;
      }
    );
  }

  onFormatStatus(str) {
    return str ? str.replace(/_/g, " ") : '';
  }

  onEmailMeClicked() {
    this.emailMeDisabled = true;
  }

  onReverseClick(withdrawal) {
    return this.navigator.navigateTo("WithdrawalReverseConfirmComponent", { multipleModals: false },  { payoutRequestID: withdrawal.payoutRequestID, amount: withdrawal.amount, navigateBackPage: 'PendingWithdrawalsComponent' });
  }
}
